import { h } from 'preact';

import { useSelector } from 'react-redux';

function getUserInfo(state) {
  return state.rpmAccountData.data;
}

function isRebelMouseUser(user) {
  return user.verified && user.externalEmail.endsWith('@rebelmouse.com');
}

export default function IsRebelmouseStaff(props) {
  const { children } = props;

  const user = useSelector(getUserInfo);

  const shouldDisplay = user ? isRebelMouseUser(user) : false;

  if (shouldDisplay) {
    return children;
  } else {
    return null;
  }
}
